const basketResponseEvent = (res, basketUrl, redirect) => {
    if (!res.success) {
        // do something
        const failEvent = new CustomEvent('reservation.failed', {
            detail: res.message ? res.message : 'Something went wrong while adding the item to your basket. Please try again.',
        });
        window.dispatchEvent(failEvent);
        // console.log('Failed reservation, emitting event');
        return;
    }
    if (redirect) {
        window.location.href = basketUrl;
    }
};
export default basketResponseEvent;
